import React from "react";
import InputNumber from "rc-input-number";
import "../../../css/rc_number_input.scss";

interface InputFormProp {
	name?: string;
	initial_value: number;
	updateFunc: Function;
	do_not_update_initially?: boolean;
	disabled?: boolean;
	allow_zero?: boolean;
}

interface InputFormState {
	value: number;
}

export class NumberInputForm extends React.Component<
	InputFormProp,
	InputFormState
> {
	constructor(props) {
		super(props);

		let value = props.initial_value;

		this.state = {
			value: value,
		};

		this.handleChange = this.handleChange.bind(this);

		if (!this.props.do_not_update_initially) this.props.updateFunc(value);
	}

	// TODO: Storing redundant state on both this form and its parent, fix??
	handleChange(event) {
		let value = event ?? 0;
		if (!this.props.allow_zero && event < 1) {
			value = null;
		}

		this.setState({ value: value });
		this.props.updateFunc(value);
	}

	render() {
		return (
			<div>
				<InputNumber
					disabled={Boolean(this.props.disabled)}
					placeholder={"NONE"}
					type="number"
					inputMode="numeric"
					min={0}
					max={10000}
					step={1}
					value={this.state.value}
					onChange={this.handleChange}
					parser={(str) => {
						return str.replace(/\D/, "");
					}}
				/>
			</div>
		);
	}
}
